// extracted by mini-css-extract-plugin
module.exports = {"loginWrapper":"Login_loginWrapper__3DGJL","loginCenter":"Login_loginCenter__XAR6X","loginLogo":"Login_loginLogo__y_Vj4"};